import { InferResponseType } from "hono/client";
import { client } from "../client";

export const MONTHLY_LEADERBOARD_QUERY_KEY = ["monthlyLeaderboard"];

export type LeaderboardEntry = InferResponseType<
  typeof client.leaderboards.$get,
  200
>[0];

export type MonthlyLeaderboardResponse = LeaderboardEntry[];
